import React, { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { http } from "@/lib/api";
import { useOptions } from "@/hooks/useOptions";
import { FormDrawer } from "@/components/kit/FormDrawer";
import { SelectField } from "@/components/kit/fields";
import { toast } from "sonner";

export function EditCardDrawer({ open, card, onOpenChange }) {
  const opts = useOptions();
  const qc = useQueryClient();
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open && card) setForm({ product_id: card.product_id || "", vertical: card.vertical, payment_model: card.payment_model,
      currency: card.currency, advertiser_id: card.advertiser_id || "" });
  }, [open, card]);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const save = async () => {
    setBusy(true);
    try {
      await http.put(`/offer-cards/${card.id}`, form);
      qc.invalidateQueries({ queryKey: ["offer-card", card.id] });
      qc.invalidateQueries({ queryKey: ["offer-cards"] });
      toast.success("Card saved");
      onOpenChange(false);
    } catch (e) { toast.error(e.response?.data?.detail || "Save failed"); }
    finally { setBusy(false); }
  };

  const vertOpts = Array.from(new Set([...(opts.verticals || []), form.vertical].filter(Boolean)));

  return (
    <FormDrawer open={open} onOpenChange={onOpenChange} title="Edit card" subtitle={card?.product_name}
      size="md" onSave={save} saving={busy} saveLabel="Save card" testId="edit-card-drawer">
      <div className="space-y-5">
        <SelectField label="Product" value={form.product_id || ""} onChange={(v) => set("product_id", v)}
          options={(opts.products || []).map((p) => ({ value: p.id, label: p.name }))}
          placeholder="Select product..." testId="card-base-product"
          hint="The product name is the offer name — switching it renames the offer everywhere." />
        <SelectField label="Advertiser" value={form.advertiser_id || ""} onChange={(v) => set("advertiser_id", v)}
          options={(opts.advertisers || []).map((a) => ({ value: a.id, label: a.name }))}
          placeholder="Select advertiser..." testId="card-base-advertiser" />
        <SelectField label="Vertical" value={form.vertical || ""} onChange={(v) => set("vertical", v)} options={vertOpts} testId="card-base-vertical" />
        <div className="grid grid-cols-2 gap-4">
          <SelectField label="Default payment model" value={form.payment_model || ""} onChange={(v) => set("payment_model", v)} options={opts.payment_models} testId="card-base-model" />
        </div>
      </div>
    </FormDrawer>
  );
}
